import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class NetworkError extends EluveError {
  static override readonly errorName = 'NetworkError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Network operation failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
